<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <form>
          <div class="my-5"></div>
          <div class="row">
            <div class="col-4 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">Teléfono</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-4 offset-2">
              <div class="form-group">
                <label for="exampleInputEmail1">Email</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-4 offset-1">
              <div class="form-group">
                <label for="exampleInputEmail1">¿Cómo te enteraste de esta carrera?</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
            <div class="col-4 offset-2">
              <div class="form-group">
                <label for="exampleInputEmail1">Escuela previa</label>
                <input
                  type="email"
                  class="form-control"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                />
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["clickedNext", "currentStep"],
  /* mixins: [validationMixin], */
  data() {
    return {};
  },
  created() {
    this.$emit("can-continue", { value: true });
  },
  watch: {
    $v: {
      handler: function (val) {
        if (!val.$invalid) {
          this.$emit("can-continue", { value: true });
        } else {
          this.$emit("can-continue", { value: false });
        }
      },
      deep: true,
    },
    clickedNext(val) {
      if (val === true) {
        this.$v.form.$touch();
      }
    },
  },
  /* mounted() {
    if (!this.$v.$invalid) {
      this.$emit("can-continue", { value: true });
    } else {
      this.$emit("can-continue", { value: false });
    }
  }, */
};
</script>